module.exports = __webpack_public_path__ + "img/faming10.a7ebeb90.png";